import styled, { css, keyframes } from 'styled-components';

export const FastCheckoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const AlertWrapper = styled.div`
  ${({ theme }) => css`
    > div {
      background-color: ${theme.v2.colors.neutral.highPure};
      box-shadow: 0px 0px 1px 0px #707070;
    }
    bottom: 85px;
    position: fixed;
    max-width: 469px;
    right: 62px;
    width: 100%;
    animation: ${slideIn} 0.5s ease-out;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      max-width: 300px;
      right: 20px;
    }
  `}
`;

export const LoaderWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
`;
